import { render, staticRenderFns } from "./transaction-export.vue?vue&type=template&id=4b515bfb"
import script from "./transaction-export.vue?vue&type=script&lang=js"
export * from "./transaction-export.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports